import ShoppingCart from "../services/shoppingCart/ShoppingCart";

export default class CartUpdatedMessage {
    constructor(public readonly shoppingCart: ShoppingCart, public readonly isRestore: boolean) {}
}
